import React from 'react'
import classNames from 'classnames'

import Logo from '../logo/Logo'
import User from '../header/dropdown/user/User'
import LanguageHead from '../header/dropdown/language/Language'
import { useTheme } from '../provider/Theme'
import { useSDSsearchTrigger } from '../../store/searchDataStore'

const PaymentHeader = ({ fixed, className, ...props }) => {
  const theme = useTheme()
  const searchTrigger = useSDSsearchTrigger()

  const headerClass = classNames({
    'nk-header is-regular': true,
    'nk-header-fixed': fixed,
    'is-light': theme.header === 'white',
    [`is-${theme.header}`]: theme.header !== 'white' && theme.header !== 'light',
    [`${className}`]: className
  })

  return (<div className={headerClass}>
    <div className="container-fluid">
      <div className="nk-header-wrap">
        <div className="nk-header-brand">
          <Logo/>
        </div>
        <div className='nk-header-menu ms-auto'></div>
        <div className="nk-header-tools">
          <ul className="nk-quick-nav">
            <li className={`language-dropdown d-none d-sm-block me-n1 ${searchTrigger ? 'disabled-full' : ''}`}>
              <LanguageHead/>
            </li>
            <li className="user-dropdown">
              <User/>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>)
}
export default PaymentHeader
